module.exports = __webpack_public_path__ + "img/lqsxtou_5.98e8aeb8.svg";